import ReactModal, { Props } from "react-modal";
import { isMobile } from "react-device-detect";

export const Modal = (
    props: Props & {
        children: React.ReactNode;
    }
) => {
    return (
        <>
            <ReactModal
                style={{
                    overlay: {
                        zIndex: 102 /* above homeNav */,
                        overflow: "scroll",
                        // all properties must be defined (to overwrite defaults)
                        position: "fixed",
                        // cursor: "none",
                        backgroundColor: "rgba(38, 38, 38, 0.8)",
                    },
                    content: {
                        marginBottom: "none",
                        // all properties must be defined (to overwrite defaults)
                        position: "absolute",
                        top: "0",
                        right: "0",
                        bottom: "0",
                        left: "0",
                        border: "none",
                        backgroundColor: "#FFFFFF",
                        overflow: "auto",
                        padding: "0",
                        maxWidth: "700px",
                        margin: isMobile ? "0px" : "24px auto",
                        borderRadius: isMobile ? "0px" : "10px",
                    },
                }}
                {...props}
            >
                {props.children}
            </ReactModal>
        </>
    );
};
